export default [
  {
    path: '/two-factor-authentication',
    name: 'twoFactorAuthentication',
    component: () => import('./views/auth/two-factor-authen.vue'),
  },
  {
    path: '/register-two-factor',
    name: 'registerTwoFactor',
    component: () => import('./views/auth/register-two-factor-authen.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  {
    path: '/verify/404',
    name: 'verify-404',
    component: () => import('./views/utility/verify-404'),
  },
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/pages/maintenance',
    name: 'Maintenance',
    component: () => import('./views/utility/maintenance'),
  },
  {
    path: '/pages/401',
    name: 'Error-401',
    meta: { authRequired: true },
    component: () => import('./views/utility/401'),
  },
  {
    path: '/pages/404',
    name: 'Error-404',
    meta: { authRequired: true },
    component: () => import('./views/utility/404'),
  },
  {
    path: '/config-fail',
    name: 'config-fail',
    component: () => import('./views/utility/config-fail'),
  },
  {
    path: '/pages/500',
    name: 'Error-500',
    meta: { authRequired: true },
    component: () => import('./views/utility/500'),
  }, 
  // { // disable access due to security
  //   path: '/',
  //   name: 'default',
  //   component: () => import('./views/index'),
  // },
  // {
  //   path: '/my-profile',
  //   name: 'my-profile',
  //   meta: { authRequired: true },
  //   component: () => import('./views/dashboards/my-profile'),
  // },
  // { // disable access due to security
  //   path: '/logout',
  //   name: 'logout',
  // },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('./views/auth/login-2'),
  // },
  
  // { // disable access due to security
  //   path: '/authentication/signin',
  //   name: 'signin',
  //   component: () => import('./views/auth/login-2'),
  // },
  
  // { // disable access due to security
  //   path: '/forgot-password',
  //   name: 'forgotpassword',
  //   component: () => import('./views/auth/forgot-password'),
  // },
  // { // disable access due to security
  //   path: '/reset-password/:code',
  //   name: 'resetpassword',
  //   component: () => import('./views/auth/reset-password'),
  // },
  // { // disable access due to security
  //   path: '/verify/code/:id',
  //   name: 'verify-code',
  //   component: () => import('./views/auth/verify-landing'),
  // },
  // { // disable access due to security
  //   path: '/authorize',
  //   name: 'authorize',
  //   component: () => import('./views/auth/authorize'),
  // },
  // { // disable access due to security
  //   path: '/verify/email/:email',
  //   name: 'request-verify',
  //   component: () => import('./views/auth/request-verify'),
  // },
  // { // disable access due to security
  //   path: '/verify/otp/:code',
  //   name: 'verify-otp',
  //   component: () => import('./views/auth/verify-otp-landing'),
  // },
  // { // disable access due to security
  //   path: '/oauth/callback/:provider',
  //   component: {
  //     template: '<div class="auth-component"></div>'
  //   }
  // },
  // { // disable access due to security
  //   path: '/invites/:code',
  //   name: 'verify-invites',
  //   component: () => import('./views/auth/verify-invite-landing'),
  // }
]